import { Star, Quote, User } from 'lucide-react';

const reviews = [
  {
    id: 1,
    author: "Paul Binkley",
    rating: 5,
    text: "Edin went above and beyond to install our new network. He took great care to make sure we are up and running and assisted with our new phone system for VOIP. Took extra care on training of the features of the new network and phone system. I would definitely recommend XXL IT Services.",
    date: "2026-03-06"
  },
  {
    id: 2,
    author: "Joyce Baker",
    rating: 5,
    text: "Eddie is the best! Went above and beyond to assist me with my internet connection. He put in new cabling outside the building and took extra care to make sure everything was working properly. Even vacuumed after! Highly recommend this guy - he is honest and trustworthy.",
    date: "2025-11-20"
  },
  {
    id: 3,
    author: "Heather Jimenez",
    rating: 5,
    text: "Highly recommend XXL IT if you're in the Treasure Valley! We needed help setting up internet ASAP and Edin came out the same day and had us up and running in less than an hour! He was great to work with, incredibly knowledgeable.",
    date: "2025-09-20"
  }
];

export function GoogleReviews() {
  return (
    <section className="py-20 bg-navy-950 border-t border-white/5">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-white">What Our Clients Say</h2>
          <div className="flex items-center justify-center mb-4">
            {[...Array(5)].map((_, i) => (
              <Star key={i} className="w-6 h-6 text-yellow-400 fill-current" />
            ))}
          </div>
          <p className="text-xl text-gray-300">
            5.0 rating based on 30 Google Reviews
          </p>
          <a
            href="https://g.co/kgs/w7e81en"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center mt-2 text-cobalt-400 hover:text-cobalt-300 transition-colors"
          >
            View all reviews on Google
          </a>
        </div>

        <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {reviews.map((review) => (
            <div
              key={review.id}
              className="bg-white/5 border border-white/10 backdrop-blur-sm p-6 rounded-2xl relative"
            >
              <Quote className="absolute top-4 right-4 w-8 h-8 text-white/10" />
              <div className="flex items-center mb-4">
                {[...Array(review.rating)].map((_, i) => (
                  <Star key={i} className="w-5 h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              <p className="text-gray-300 mb-4">
                "{review.text}"
              </p>
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="w-10 h-10 rounded-full bg-cobalt-500/20 flex items-center justify-center mr-3">
                    <User className="w-6 h-6 text-cobalt-400" />
                  </div>
                  <div>
                    <p className="font-semibold text-white">
                      {review.author}
                    </p>
                    <p className="text-sm text-gray-400">
                      {new Date(review.date).toLocaleDateString()}
                    </p>
                  </div>
                </div>
                <div className="flex items-center">
                  <img
                    src="https://www.gstatic.com/images/branding/googlelogo/svg/googlelogo_clr_74x24px.svg"
                    alt="Google Reviews logo"
                    className="h-6 w-auto"
                    loading="lazy"
                    width="74"
                    height="24"
                    title="Google Reviews for XXL IT Services"
                  />
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <a
            href="https://g.co/kgs/w7e81en"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center px-6 py-3 border border-white/20 text-base font-medium rounded-full text-white bg-white/5 hover:bg-white/10 transition-colors"
          >
            Write a Review
          </a>
        </div>
      </div>
    </section>
  );
}
